import { render, staticRenderFns } from "./TopBar.vue?vue&type=template&id=5cc08996&scoped=true&"
import script from "./TopBar.vue?vue&type=script&lang=js&"
export * from "./TopBar.vue?vue&type=script&lang=js&"
import style0 from "./TopBar.vue?vue&type=style&index=0&id=5cc08996&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cc08996",
  null
  
)

export default component.exports